// Interactive piece guide and movement rules for Chess and Xiangqi

export const PIECE_GUIDES = {
  chess: {
    P: {
      name: 'Tốt Trắng (White Pawn)',
      rule: 'Đi thẳng 1 ô (hoặc 2 ô ở nước đầu), ăn chéo 1 ô phía trước. Phong cấp khi đến hàng 8, hỗ trợ bắt tốt qua đường.'
    },
    p: {
      name: 'Tốt Đen (Black Pawn)',
      rule: 'Đi thẳng 1 ô (hoặc 2 ô ở nước đầu), ăn chéo 1 ô phía trước. Phong cấp khi đến hàng 1, hỗ trợ bắt tốt qua đường.'
    },
    N: {
      name: 'Mã Trắng (White Knight)',
      rule: 'Đi theo hình chữ L (2 ô một hướng rồi 1 ô vuông góc). Có thể nhảy qua đầu các quân cờ khác.'
    },
    n: {
      name: 'Mã Đen (Black Knight)',
      rule: 'Đi theo hình chữ L (2 ô một hướng rồi 1 ô vuông góc). Có thể nhảy qua đầu các quân cờ khác.'
    },
    B: {
      name: 'Tượng Trắng (White Bishop)',
      rule: 'Đi chéo không giới hạn số ô theo đường chéo cùng màu xuất phát. Không thể nhảy qua quân khác.'
    },
    b: {
      name: 'Tượng Đen (Black Bishop)',
      rule: 'Đi chéo không giới hạn số ô theo đường chéo cùng màu xuất phát. Không thể nhảy qua quân khác.'
    },
    R: {
      name: 'Xe Trắng (White Rook)',
      rule: 'Đi thẳng ngang hoặc dọc không giới hạn khoảng cách khi không bị cản. Hỗ trợ nhập thành cùng Vua.'
    },
    r: {
      name: 'Xe Đen (Black Rook)',
      rule: 'Đi thẳng ngang hoặc dọc không giới hạn khoảng cách khi không bị cản. Hỗ trợ nhập thành cùng Vua.'
    },
    Q: {
      name: 'Hậu Trắng (White Queen)',
      rule: 'Đi thẳng ngang, dọc hoặc chéo không giới hạn số ô. Là quân cờ mạnh và cơ động nhất.'
    },
    q: {
      name: 'Hậu Đen (Black Queen)',
      rule: 'Đi thẳng ngang, dọc hoặc chéo không giới hạn số ô. Là quân cờ mạnh và cơ động nhất.'
    },
    K: {
      name: 'Vua Trắng (White King)',
      rule: 'Đi 1 ô về mọi hướng (ngang, dọc, chéo). Không được đi vào ô bị đối phương kiểm soát (bị chiếu).'
    },
    k: {
      name: 'Vua Đen (Black King)',
      rule: 'Đi 1 ô về mọi hướng (ngang, dọc, chéo). Không được đi vào ô bị đối phương kiểm soát (bị chiếu).'
    }
  },
  xiangqi: {
    K: {
      name: 'Tướng Đỏ (Red General)',
      rule: 'Đi từng ô một (ngang hoặc dọc) trong Cung tướng 3×3. Luật Phi Tướng: Hai Tướng không được nhìn thẳng mặt nhau khi không có quân cản.'
    },
    k: {
      name: 'Tướng Đen (Black General)',
      rule: 'Đi từng ô một (ngang hoặc dọc) trong Cung tướng 3×3. Luật Phi Tướng: Hai Tướng không được nhìn thẳng mặt nhau khi không có quân cản.'
    },
    A: {
      name: 'Sĩ Đỏ (Red Advisor)',
      rule: 'Đi chéo đúng 1 ô mỗi nước và chỉ di chuyển trong Cung tướng để bảo vệ Tướng.'
    },
    a: {
      name: 'Sĩ Đen (Black Advisor)',
      rule: 'Đi chéo đúng 1 ô mỗi nước và chỉ di chuyển trong Cung tướng để bảo vệ Tướng.'
    },
    E: {
      name: 'Tượng Đỏ (Red Elephant)',
      rule: 'Đi chéo 2 ô (hình chữ điền), không được qua sông. Bị cản nếu có quân ở mắt Tượng (ô giữa).'
    },
    e: {
      name: 'Tượng Đen (Black Elephant)',
      rule: 'Đi chéo 2 ô (hình chữ điền), không được qua sông. Bị cản nếu có quân ở mắt Tượng (ô giữa).'
    },
    H: {
      name: 'Mã Đỏ (Red Horse)',
      rule: 'Đi hình chữ L (1 ô thẳng + 1 ô chéo). Bị cản chân Mã nếu có quân đứng ngay sát phía trước hướng xuất phát.'
    },
    h: {
      name: 'Mã Đen (Black Horse)',
      rule: 'Đi hình chữ L (1 ô thẳng + 1 ô chéo). Bị cản chân Mã nếu có quân đứng ngay sát phía trước hướng xuất phát.'
    },
    R: {
      name: 'Xe Đỏ (Red Chariot)',
      rule: 'Đi thẳng ngang hoặc dọc không giới hạn khoảng cách khi không bị cản, ăn quân tại ô đến.'
    },
    r: {
      name: 'Xe Đen (Black Chariot)',
      rule: 'Đi thẳng ngang hoặc dọc không giới hạn khoảng cách khi không bị cản, ăn quân tại ô đến.'
    },
    C: {
      name: 'Pháo Đỏ (Red Cannon)',
      rule: 'Đi ngang/dọc như Xe khi không ăn quân. Khi ăn quân bắt buộc phải nhảy qua đúng 1 quân cản (ngòi pháo).'
    },
    c: {
      name: 'Pháo Đen (Black Cannon)',
      rule: 'Đi ngang/dọc như Xe khi không ăn quân. Khi ăn quân bắt buộc phải nhảy qua đúng 1 quân cản (ngòi pháo).'
    },
    P: {
      name: 'Binh Đỏ (Red Soldier)',
      rule: 'Trước khi qua sông chỉ đi thẳng 1 ô. Sau khi qua sông được đi thẳng hoặc đi ngang 1 ô. Không được đi lùi.'
    },
    p: {
      name: 'Tốt Đen (Black Soldier)',
      rule: 'Trước khi qua sông chỉ đi thẳng 1 ô. Sau khi qua sông được đi thẳng hoặc đi ngang 1 ô. Không được đi lùi.'
    }
  }
};

export function getPieceGuide(gameType, pieceChar) {
  if (!gameType || !pieceChar) return null;
  return PIECE_GUIDES[gameType]?.[pieceChar] || null;
}
